export default function TablaCelulares({ celulares, onEdit, onDelete, onVender }) {
  if (celulares.length === 0) {
    return <div className="inv-empty-state">No se encontraron celulares registrados.</div>
  }

  return (
    <div className="inv-table-responsive animate-fade-in">
      <table className="inv-table">
        <thead>
          <tr>
            <th>Modelo</th>
            <th>Capacidad</th>
            <th>Color</th>
            <th>Precio</th>
            <th>Condición</th>
            <th>Batería</th>
            <th>Estado</th>
            <th className="text-right">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {celulares.map(item => (
            <tr key={item.id}>
              <td className="inv-td-model">{item.modelo}</td>
              <td>{item.capacidad || '—'}</td>
              <td>{item.color || '—'}</td>
              <td className="inv-td-price">
                {item.precio > 0 ? `US$ ${Number(item.precio).toLocaleString()}` : `ARS$ ${Number(item.precio_ars).toLocaleString('es-AR')}`}
              </td>
              <td>{item.estado_estetico}</td>
              <td>{item.bateria || '—'}</td>
              <td><span className={`inv-badge badge-${item.estado_venta}`}>{item.estado_venta}</span></td>
              <td>
                <div className="inv-actions-cell">
                  {item.estado_venta === 'disponible' && (
                    <button 
                      onClick={() => onVender(item)} 
                      className="btn-table-edit" 
                      style={{ backgroundColor: '#28a745', color: 'white', borderColor: '#28a745', marginRight: '5px' }}
                      title="Registrar Venta Directa"
                    >
                      Vender
                    </button>
                  )}
                  <button onClick={() => onEdit(item)} className="btn-table-edit">Editar</button>
                  <button onClick={() => onDelete(item.id)} className="btn-table-delete">Borrar</button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}